<oo-loading-container [status]="state.status">
  <ng-template>
    <h1 mat-dialog-title>Create new competition</h1>
    <mat-dialog-content [formGroup]="state.form">
      <mat-form-field>
        <input
          formControlName="name"
          matInput
          placeholder="Name"/>
        <mat-error>Required</mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Select Tournament</mat-label>
        <mat-select formControlName="tournamentId">
          @for (tour of state.tournaments; track tour.id) {
            <mat-option [value]="tour.id">
              {{ tour.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>
        Cancel
      </button>
      <button (click)="createCompGroup()"
              [disabled]="state.form.invalid" [mat-dialog-close]="true"
              color="primary"
              mat-button>
        Confirm
      </button>
    </mat-dialog-actions>
  </ng-template>
</oo-loading-container>
